// Import model
import { VinylCatalogItemCondition } from '../models/VinylCatalogItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { VinylCatalogItemIndexedFields } from '../models/VinylCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { VinylCatalogItemIndexedFieldsSerializer } from './VinylCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for VinylCatalogItemCondition - handles JSON serialization and deserialization with type validation
 */
export class VinylCatalogItemConditionSerializer {
  /**
   * Deserializes a JSON string into a VinylCatalogItemCondition instance
   */
  static deserialize(json: string): VinylCatalogItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a VinylCatalogItemCondition instance
   */
  static fromObject(obj: any): VinylCatalogItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to VinylCatalogItemCondition');
    }


    const instance: VinylCatalogItemCondition = {
      fieldName: obj['fieldName'] as VinylCatalogItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of VinylCatalogItemCondition instances
   */
  static deserializeArray(json: string): VinylCatalogItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a VinylCatalogItemCondition instance to a JSON string
   */
  static serialize(instance: VinylCatalogItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a VinylCatalogItemCondition instance to a plain object
   */
  static toObject(instance: VinylCatalogItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of VinylCatalogItemCondition instances to a JSON string
   */
  static serializeArray(instances: VinylCatalogItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
